import React from 'react';
import PropTypes from 'prop-types';
import Label from "semantic-ui-react/dist/es/elements/Label/Label.js";
export var Component = function Component(_ref) {
  var errorMessage = _ref.errorMessage;
  return React.createElement(Label, {
    color: "red",
    pointing: "below"
  }, errorMessage);
};
Component.displayName = 'ErrorMessage';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  errorMessage: PropTypes.string.isRequired
} : {};